import { ServiceProps } from './Service';
import { Observable } from 'rxjs';
import Analytics from '@withlocals/withlocals-analytics';
import { isCordova } from 'utils/platform';
import useAuthStore from '~/authentication/store';
import { OneSignalService } from 'services/OneSignal';

export interface PushMessage {
  type: string;

  [key: string]: string;

  city?: string;
  country?: string;
  id?: string;
}

interface PushMessageHandlerService {
  startPush: () => void;
  pushEvents$: Observable<PushMessage>;
}

interface PushProviders {
  oneSignalService: OneSignalService;
}

export function PushMessageHandler(props: ServiceProps, { oneSignalService }: PushProviders): PushMessageHandlerService {

  if (!oneSignalService) {
    console.error('PushMessageHandler: oneSignalService is not defined');
    return {
      startPush: () => { console.log('PushMessageHandler: oneSignalService is not defined'); },
      pushEvents$: Observable.of<PushMessage>(),
    };
  }

  const startPush = () => {
    if (isCordova()) {
      oneSignalService.requestPushPermissions();
    } else {
      console.log('Starting push service on web will fail');
    }
  };

  const notificationOpens$ = oneSignalService.notificationOpensData$;

  const notificationReceive$ = Observable.merge(oneSignalService.notificationReceivesData$);

  notificationOpens$.subscribe(
    m => console.log('PushMessageHandler', JSON.stringify(m)),
    e => console.error('PushMessageHandler', e));

  notificationOpens$
    .filter(({ templateName }) => !!templateName)
    .map(({ templateName, language }) => ({ templateName, language }))
    .subscribe((event) => {
      Analytics.track('App', 'PushMessageOpen', `${event.templateName}_${event.language}`);
    });

  notificationReceive$
    .filter(({ templateName }) => !!templateName)
    .map(({ templateName, language }) => ({ templateName, language }))
    .subscribe((event) => {
      Analytics.track('App', 'PushMessageReceive', `${event.templateName}_${event.language}`);
    });

  notificationOpens$
    .filter(({ type, id }) => type === 'booking' && !!id)
    .subscribe(({ id }) => props.flux.actions.menu.toSelectedSchedule(id));

  notificationOpens$
    .filter(({ type, id }) => type === 'message' && !!id)
    .subscribe(({ id }) => props.flux.actions.menu.toSelectedMessage(id));

  notificationOpens$
    .filter(({ type, city, country }) => type === 'search' && !!city && !!country)
    .subscribe(({ city, country }) => props.flux.actions.menu.findThingsToDoIn(country, city));

  notificationOpens$
    .filter(({ type }) => type === 'url')
    .subscribe(({ url }) => props.flux.actions.menu.goTo(url));

  useAuthStore.subscribe((state) => state.user, (user) => {
    if (!user?.id) {
      return;
    }
    startPush();
  });

  return {
    startPush,
    pushEvents$: Observable.merge(notificationReceive$, notificationOpens$),
  };
}
